import { render, staticRenderFns } from "./cerfagaz.vue?vue&type=template&id=0ec1097c&scoped=true&"
import script from "./cerfagaz.vue?vue&type=script&lang=js&"
export * from "./cerfagaz.vue?vue&type=script&lang=js&"
import style0 from "./cerfagaz.vue?vue&type=style&index=0&id=0ec1097c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec1097c",
  null
  
)

export default component.exports